// カテゴリフィルターのデフォルト値
export const defaultCategoryFilter = {
  movie: true,
  drama: true,
  manga: true,
  anime: true,
  game: true,
  trivia: false
};

// 時代設定フィルターのデフォルト値
export const defaultSettingTypesFilter = ['contemporary', 'past', 'future'];
